/**
 * 无投影
 * @description enDesc: No shadow
 * @description type: global
 * @description  globalToken: -
 * @description  value: none
 */
var $shadow_0 = 'none';

/**
 * 投影1
 * @description enDesc: Special shadow
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0px 8px 20px 0px rgba(0, 0, 0, 0.15)
 */
var $shadow_1 = '0px 8px 20px 0px rgba(0, 0, 0, 0.15)';

/**
 * 投影1-上
 * @description enDesc: Shadow 1 - Centered
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0px -2px 5p x rgba(22,22,26,0.10)
 */
var $shadow_1_up = '0px -2px 5px rgba(22,22,26,0.10)';

/**
 * 投影1-下
 * @description enDesc: Shadow 1-
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0px 2px 5px rgba(22,22,26,0.10)
 */
var $shadow_1_down = '0px 2px 5px rgba(22,22,26,0.10)';

/**
 * 投影1-左
 * @description enDesc: Shadow 1-
 * @description type: global
 * @description  globalToken: -
 * @description  value: -2px 0px 5px rgba(22,22,26,0.10)
 */
var $shadow_1_left = '-2px 0px 5px rgba(22,22,26,0.10)';

/**
 * 投影1-右
 * @description enDesc: Shadow 1 - Left
 * @description type: global
 * @description  globalToken: -
 * @description  value: 2px 0px 5px rgba(22,22,26,0.10)
 */
var $shadow_1_right = '2px 0px 5px rgba(22,22,26,0.10)';

/**
 * 投影2
 * @description enDesc: Shadow 2
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0px 3px 8px 3px rgba(22,22,26,0.10)
 */
var $shadow_2 = '0px 3px 8px 3px rgba(22,22,26,0.10)';

/**
 * 投影2-上
 * @description enDesc: Shadow 2 - Centered
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0px -3px 8px rgba(22,22,26,0.10)
 */
var $shadow_2_up = '0px -3px 8px rgba(22,22,26,0.10)';

/**
 * 投影2-下
 * @description enDesc: Shadow 2 - Down
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0px 3px 8px rgba(22,22,26,0.10)
 */
var $shadow_2_down = '0px 3px 8px rgba(22,22,26,0.10)';

/**
 * 投影2-左
 * @description enDesc: Shadow 2 - Left
 * @description type: global
 * @description  globalToken: -
 * @description  value: -3px 0px 8px rgba(22,22,26,0.10)
 */
var $shadow_2_left = '-3px 0px 8px rgba(22,22,26,0.10)';

/**
 * 投影2-右
 * @description enDesc: Shadow 2 - Right
 * @description type: global
 * @description  globalToken: -
 * @description  value: 3px 0px 8px rgba(22,22,26,0.10)
 */
var $shadow_2_right = '3px 0px 8px rgba(22,22,26,0.10)';

/**
 * 投影3
 * @description enDesc: Shadow 3
 * @description type: global
 * @description  globalToken: -
 * @description  value: '0px 8px 20px 0px rgba(0, 0, 0, 0.15)'
 */
var $shadow_3 = '0px 8px 20px 0px rgba(0, 0, 0, 0.15)';

/**
 * 投影3-上
 * @description enDesc: Shadow 3 - Centered
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0px -2px 20px 0px rgba(22,22,26,0.10)
 */
var $shadow_3_up = '0px -2px 20px 0px rgba(22,22,26,0.10)';

/**
 * 投影3-下
 * @description enDesc: Shadow 3 - Down
 * @description type: global
 * @description  globalToken: -
 * @description  value: 0px 2px 20px 0px rgba(22,22,26,0.10)
 */
var $shadow_3_down = '0px 2px 20px 0px rgba(22,22,26,0.10)';

/**
 * 投影3-左
 * @description enDesc: Shadow 3 - Left
 * @description type: global
 * @description  globalToken: -
 * @description  value: -2px 0px 20px 0px rgba(22,22,26,0.10)
 */
var $shadow_3_left = '-2px 0px 20px 0px rgba(22,22,26,0.10)';

/**
 * 投影3-右
 * @description enDesc: Shadow 3 - Right
 * @description type: global
 * @description  globalToken: -
 * @description  value: 2px 0px 20px 0px rgba(22,22,26,0.10)
 */
var $shadow_3_right = '2px 0px 20px 0px rgba(22,22,26,0.10)';

/**
 * 最平的投影
 * @description enDesc: Shadow 3 - Right
 * @description type: alias
 * @description  globalToken: $shadow-0
 * @description  value: none
 */
var $shadow_flat = $shadow_0;

/**
 * 普通容器的阴影
 * @description enDesc: Shadow 3 - Right
 * @description type: alias
 * @description  globalToken: $shadow-1-up, $shadow-1-left, $shadow-1-right, $shadow-1-down
 * @description  value: 0px -2px 4px rgba(22,22,26,0.10), -2px 0px 4px rgba(22,22,26,0.10), 2px 0px 4px rgba(22,22,26,0.10), 0px 2px 4px rgba(22,22,26,0.10)
 */
var $shadow_container = '0px -2px 4px rgba(22,22,26,0.10), -2px 0px 4px rgba(22,22,26,0.10), 2px 0px 4px rgba(22,22,26,0.10), 0px 2px 4px rgba(22,22,26,0.10)';

/**
 * 弹窗的阴影
 * @description enDesc: Shadow 3 - Right
 * @description type: alias
 * @description  globalToken: $shadow-2-up, $shadow-2-left, $shadow-2-right, $shadow-2-down
 * @description  value: 0px -3px 8px 3px rgba(22,22,26,0.10), -3px 0px 8px 3px rgba(22,22,26,0.10), 3px 0px 8px 3px rgba(22,22,26,0.10), 0px 3px 8px 3px rgba(22,22,26,0.10)
 */
var $shadow_elevated = '0px -3px 8px 3px rgba(22,22,26,0.10), -3px 0px 8px 3px rgba(22,22,26,0.10), 3px 0px 8px 3px rgba(22,22,26,0.10), 0px 3px 8px 3px rgba(22,22,26,0.10)';

/**
 * 引人关注容器的阴影
 * @description enDesc: Shadow 3 - Right
 * @description type: alias
 * @description  globalToken: $shadow-3-up, $shadow-3-left, $shadow-3-right, $shadow-3-down
 * @description  value: 0px -4px 20px 0px rgba(22,22,26,0.10), -4px 0px 20px 0px rgba(22,22,26,0.10), 4px 0px 20px 0px rgba(22,22,26,0.10), 0px 4px 20px 0px rgba(22,22,26,0.10)
 */
var $shadow_spotlight = '0px -4px 20px 0px rgba(22,22,26,0.10), -4px 0px 20px 0px rgba(22,22,26,0.10), 4px 0px 20px 0px rgba(22,22,26,0.10), 0px 4px 20px 0px rgba(22,22,26,0.10)';

export { $shadow_0, $shadow_1, $shadow_1_down, $shadow_1_left, $shadow_1_right, $shadow_1_up, $shadow_2, $shadow_2_down, $shadow_2_left, $shadow_2_right, $shadow_2_up, $shadow_3, $shadow_3_down, $shadow_3_left, $shadow_3_right, $shadow_3_up, $shadow_container, $shadow_elevated, $shadow_flat, $shadow_spotlight };
